module.exports = __webpack_public_path__ + "media/components/swell-preview/static/surfscale-metric-7bcc88c8751ace48459dfc3fa6e250fd.svg";